export enum SocketReduxActions {
    SOCKET_INITIAL_HANDSHAKE = 'SOCKET_INITIAL_HANDSHAKE',
    TO_SOCKET_REDUX_WORKER = 'TO_SOCKET_REDUX_WORKER',
    TO_SOCKET_INITIAL_HANDSHAKE = 'TO_SOCKET_INITIAL_HANDSHAKE',
    TO_REMOVE_SOCKET_EVENT = 'TO_REMOVE_SOCKET_EVENT',
    TO_REMOVE_SOCKET_COUNTER = 'TO_REMOVE_SOCKET_COUNTER',
    SOCKET_CLOSE_HANDSHAKE = 'SOCKET_CLOSE_HANDSHAKE',
    ACTION_REDUX_WORKER = 'SOCKET_ACTION_REDUX_WORKER',
}

const SetSocketCloseHandshake = (payload: any): any => ({
    type: SocketReduxActions.SOCKET_CLOSE_HANDSHAKE,
    payload,
});
const SetSocketInitialHandshake = (payload: any): any => ({
    type: SocketReduxActions.SOCKET_INITIAL_HANDSHAKE,
    payload,
});

const SetSocketReduxWorker = (payload: any): any => ({
    type: SocketReduxActions.TO_SOCKET_REDUX_WORKER,
    payload,
});

const ResetSocketEvent = (payload: any): any => ({
    type: SocketReduxActions.TO_REMOVE_SOCKET_EVENT,
    payload,
});

const ResetSocketCounter = (): any => ({
    type: SocketReduxActions.TO_REMOVE_SOCKET_COUNTER,
    payload: null,
});

const SetActionReduxWorker = (payload: any): any => ({
    type: SocketReduxActions.ACTION_REDUX_WORKER,
    payload,
});

const SetSocketActivity = (payload: any): any => ({
    type: SocketReduxActions.TO_SOCKET_INITIAL_HANDSHAKE,
    payload,
});

export const SocketActions = {
    SetSocketInitialHandshake,
    SetSocketCloseHandshake,
    SetSocketReduxWorker,
    ResetSocketEvent,
    ResetSocketCounter,
    SetActionReduxWorker,
    SetSocketActivity,
};
